export default __webpack_public_path__ + "static/media/Rogerio.b92f2093.png";